<template>
  <qc-container title="提现管理">
    <page-request ref="table" url="/api/business/shop/income/list" :table-header="tableHeader" :expend="expend"  :op-width="100">
      <template #op="scope">
        <b-button v-if="scope.row.status!==0" @click="toDetail(scope.row)">查看</b-button>
        <b-button v-else="" @click="toDetail(scope.row)">审核</b-button>
      </template>
    </page-request>
  </qc-container>
  <withdraw-detail-drawer @load="pageReloadData" ref="detail"></withdraw-detail-drawer>
</template>

<script>
import QcContainer from "/src/components/el/layout/qc-container.vue";
import TButton from "@/components/el/t-button.vue";
import PageRequest from "@/components/base/page-request.vue";
import BButton from "@/components/el/b-button.vue";
import WithdrawDetailDrawer from "@view/finance/op/withdraw-detail.vue";

export default {
  name: "withdraw",
  components: {WithdrawDetailDrawer,  BButton, PageRequest, TButton, QcContainer},
  data() {
    return {
      tableHeader: [
        {prop: "createTime", label: "日期",width: 160},
        {type: "shop", label: "商家",width:300},
        {prop: "money", label: "提现金额(元)",width: 100},
        {prop: "commissionMoney", label: "手续费(元)",width: 100},
        {prop: "actualMoney", label: "实际到账(元)",width: 100},
        {prop: "code", label: "提现编号",width: 100},
        {label: "状态",renderDraw:row=>{
            return ['待审核','成功','失败'][row.status];
          },width: 100},
        {prop: "errorMsg", label: "说明"},
      ],
      expend:[
        {label: "日期", start: "startTime", end: "endTime", type: "daterange"},
        {label: "状态", prop: "status",type:"select",options:[{label:"待审核",value:"0"},{label:"成功",value:"1"},{label:"失败",value:"2"}]},
        {label: "提现编号",prop: "code"},
        {label: "商家名称",prop: "shopName"},
        {label: "商家账号",prop: "shopAccount"},
        {label: "店铺类型", prop: "shopType",type:"select",options:[{label:"加盟商",value:"0"},{label:"实体店",value:"1"}]},
      ]
    }
  },
  mixins: [tableBase],
  methods: {
    toDetail(row){
      this.$refs.detail&&this.$refs.detail.open(row);
    }
  },
  mounted() {

  }
}
</script>


<style lang="less" scoped>
</style>
